import { NgModule, Injectable, Component } from '@angular/core';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

import { SeoSummaryComponent } from './summary/summary.component';
import { SeoIssuesComponent } from './issues/issues.component';
import { SeoPagesComponent } from './pages/pages.component';

@Injectable({ providedIn: 'root' })
export class SeoAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('seo_all')) {
            return true;
        }

        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.domain.dashboard', params) as unknown as Promise<void>;
        });
    }
}

@Component({
    selector: 'base-seo',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseSEOComponent {}

const seoStates: Ng2StateDeclaration[] = [
    // Access-controlled abstract route
    {
        name: 'base.customer.domain.seo',
        url: '/seo',
        abstract: true,
        views: {
            'content@base.customer.domain': {
                component: BaseSEOComponent,
            },
        },
        data: {
            featureName: 'seo_all',
            redirectURI: 'base.customer.domain.dashboard',
            sidebar: 'seo',
            title: undefined,
            htmlContent: '<div ui-view></div>',
        },
        resolve: [
            {
                token: 'seoAccess',
                deps: [SeoAccessGuard, Transition],
                resolveFn: (guard: SeoAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
    },

    // Child routes with components
    {
        name: 'base.customer.domain.seo.summary',
        url: '/',
        views: {
            'content@base.customer.domain.seo': {
                component: SeoSummaryComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Search Engine Optimization',
            htmlContent: '<div ui-view></div>',
        },
    },

    {
        name: 'base.customer.domain.seo.issues',
        url: '/checkpoints',
        views: {
            'content@base.customer.domain.seo': {
                component: SeoIssuesComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - SEO Checkpoints',
            htmlContent: '<div ui-view></div>',
        },
    },

    {
        name: 'base.customer.domain.seo.pages',
        url: '/pages-with-opportunities',
        views: {
            'content@base.customer.domain.seo': {
                component: SeoPagesComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Pages With Opportunity',
            htmlContent: '<div ui-view></div>',
        },
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states: seoStates })],
    exports: [UIRouterModule],
})
export class SeoRoutingModule { }
